import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { TarlV3Jsonapi } from '®shared/tarl-v3-jsonapi';

import { Tenant } from './tenant';

@Injectable()
export class TenantService {
  constructor(private tarlV3Jsonapi: TarlV3Jsonapi) {}

  getTenant(): Observable<Tenant> {
    return this.tarlV3Jsonapi.getResource<Tenant>(null);
  }
}
